import { ApiClient } from "../api.client";
import {
  GetAdminsRequest,
  GetAdminsResponse,
  SetAdminStatusRequest,
  SetAdminStatusResponse,
} from "./types";

const AdminsApi = {
  getAdmins(params?: GetAdminsRequest) {
    return ApiClient.get<GetAdminsResponse>("/admins", { params });
  },
  setAdminStatus(body: SetAdminStatusRequest) {
    return ApiClient.post<
      Omit<SetAdminStatusRequest, "adminId">,
      SetAdminStatusResponse
    >(`/admins/${body.adminId}/set-status`, { status: body.status });
  },
};

export { AdminsApi };
